import { ThemeUICSSObject } from 'theme-ui';
import { spacing } from '../../util';
/* IMPORT HERE */

const label: ThemeUICSSObject = {
  variant: 'text.default',
  alignItems: 'center',
  width: 'auto',
  textTransform: 'none',
  cursor: 'pointer',

  '&:not(.radio-label)': {
    fontWeight: 'bold',
  },

  '&.required': {
    position: 'relative',
    '&::before': {
      color: 'danger',
      position: 'absolute',
      content: '"*"',
      top: 0,
      left: '-10px',
    },
  },

  '&:last-of-type': {
    'input, textarea, select': {
      mb: spacing(0),
    },
  },
};

export default label;
